<template>
    <div class="auction">
        <div v-show="routerLevel === 2">
            <div class="common-search-container common-shadow">
                <div class="common-header">
                    搜索筛选
                </div>
                <div class="content">
                    <el-form
                        :inline="true"
                        :model="searchParams"
                        @keyup.native.enter="getData">
                        <el-form-item>
                            <el-input
                                v-model="searchParams.nickname"
                                placeholder="昵称"
                                clearable />
                        </el-form-item>
                        <el-form-item>
                            <el-input
                                v-model="searchParams.mobile"
                                placeholder="手机号"
                                clearable />
                        </el-form-item>
                        <el-form-item>
                            <el-input
                                v-model="searchParams.shopname"
                                placeholder="店铺名"
                                clearable />
                        </el-form-item>
                        <el-form-item label="">
                            <el-date-picker
                                v-model="date"
                                type="daterange"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                unlink-panels
                                @change="onDatePickerChange" />
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                round
                                @click="getData">
                                查询
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div>
                <div class="common-table-title">
                    <span class="tit">
                        数据列表
                    </span>
                    <el-button
                        type="primary"
                        @click="exportData"
                        :loading="isExporting"
                        round>
                        导出
                    </el-button>
                </div>
                <el-table
                    ref="table"
                    stripe
                    class="table common-shadow"
                    :data="tableData"
                    v-loading="loading">
                    <el-table-column
                        prop="time"
                        label="申请时间"
                        min-width="140">
                        <template slot-scope="scope">
                            {{ dateFormat(scope.row.time) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="username"
                        label="用户名"
                        min-width="90" />
                    <el-table-column
                        prop="nickname"
                        label="姓名"
                        min-width="90" />
                    <el-table-column
                        prop="shopname"
                        label="店铺名"
                        min-width="90" />
                    <el-table-column
                        prop="mobile"
                        label="联系电话"
                        min-width="110" />
                    <el-table-column
                        prop="wx_code"
                        label="微信号"
                        min-width="110" />
                    <el-table-column
                        prop="category"
                        label="主营分类"
                        min-width="100" />
                    <el-table-column
                        prop="isTrade"
                        label="电商经验"
                        min-width="90">
                        <template slot-scope="scope">
                            {{ scope.row.isTrade ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="img"
                        label="图片"
                        min-width="90">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="preview(scope.row.img)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="statusRename"
                        label="状态"
                        min-width="80">
                        <template slot-scope="scope">
                            <span
                                class="status"
                                :class="{ resolve: scope.row.status === ACCEPT, reject: scope.row.status === REJECT }">
                                {{ scope.row.statusRename }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作"
                        min-width="130">
                        <template slot-scope="scope">
                            <el-button
                                v-if="scope.row.status === APPLYING"
                                type="text"
                                @click="openComfirm(scope.row.uri, ACCEPT)">
                                同意
                            </el-button>
                            <el-button
                                v-if="scope.row.status === APPLYING"
                                type="text"
                                @click="openComfirm(scope.row.uri, REJECT)">
                                拒绝
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="common-table-pagination">
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :current-page="searchParams.page"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="dataTotal" />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import { getShopClaim, applyShopClaim, exportShopClaim } from '../../../api';
import { dateFormat, downloadFile } from '../../../utils/util';
import { openComfirm } from '../../../utils/common';

const APPLYING = 'applying'; // 申请中
const ACCEPT = 'accept'; // 已同意
const REJECT = 'reject'; // 已拒绝

export default {
    name: 'ShopClaimList',
    props: {
        routerLevel: {
            type: Number,
            default: 2,
            required: true
        }
    },
    data () {
        return {
            APPLYING,
            ACCEPT,
            REJECT,
            loading: true,
            tableData: [],
            category: [],
            date: null,
            searchParams: {
                mobile: '',
                nickname: '',
                shopname: '',
                st: '',
                page: 1
            },
            pageSize: 0,
            dataTotal: 0,
            isExporting: false
        };
    },
    created () {
        this.getData();
    },
    methods: {
        async getData (page) {
            try {
                this.loading = true;
                if (page && typeof page === 'number') {
                    this.searchParams.page = page;
                } else {
                    this.searchParams.page = 1;
                }
                const res = await getShopClaim(this.searchParams);
                this.loading = false;
                if (res) {
                    const { data, meta } = res;
                    this.tableData = data;
                    if (meta) {
                        this.dataTotal = meta.total;
                        this.pageSize = meta.per_page;
                    }
                }
            } catch (err) {
                console.error(err);
                this.loading = false;
            }

        },
        async openComfirm (id, status) {
            try {
                const apiFn = () => {
                    return applyShopClaim(id, {
                        status
                    });
                };
                await openComfirm({
                    title: '提示',
                    message: status === ACCEPT ? '点击确认将审核通过！' : '点击确认将拒绝审核！',
                    apiFn,
                    successTip: status === ACCEPT ? '审核成功！' : '拒绝成功！'
                });
                const data = this.tableData.find(c => c.uri === id);
                if (data) {
                    data.status = status;
                    data.statusRename = status === ACCEPT ? '已同意' : '已拒绝';
                }
            } catch (err) {
                console.error(err);
            }
        },
        handleCurrentChange (val) {
            this.getData(val);
        },
        dateFormat (time) {
            if (!time) return '';
            return dateFormat(new Date(time * 1000), 'yyyy/MM/dd hh:mm');
        },
        onDatePickerChange (e) {
            if (e) {
                this.searchParams.st = e.join(' ~ ');
            } else {
                this.searchParams.st = '';
            }
        },
        async exportData () {
            try {
                if (this.isExporting) return;
                this.isExporting = true;
                const res = await exportShopClaim(this.searchParams);
                downloadFile(res, '入驻初审.xlsx');
            } catch (err) {
                console.error(err);
            } finally {
                setTimeout(() => {
                    this.isExporting = false;
                }, 1000);
            }
        },
        preview (urls) {
            this.$photoSwipe({
                urls
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .auction {

        .table {

            .status {
                color: #aaa;

                &.resolve {
                    color: #67C23A;
                }

                &.reject {
                    color: #F56C6C;
                }
            }
        }
    }
</style>
